import { PropertyKind } from "shared/types";

export const getPropertyKindLabel = (
  kind: PropertyKind | null | undefined
): string | null => {
  if (kind === PropertyKind.ManufacturedHousing) return "Mobile Home";
  if (kind === PropertyKind.SingleFamily) return "Single family";
  if (kind === PropertyKind.MultiFamily) return "Multi family";
  return null;
};

const PROPERTY_KIND_VALUES = new Set<string>(Object.values(PropertyKind));

const isPropertyKind = (value: string): value is PropertyKind =>
  PROPERTY_KIND_VALUES.has(value);

export const toPropertyKinds = (values: string[]): PropertyKind[] =>
  values.filter(isPropertyKind);
